export function createPulseMarkerOverlayClass() {
  class PulseMarkerOverlay extends google.maps.OverlayView {
    constructor(position) {
      super()
      this.position = new google.maps.LatLng(position.lat, position.lng)
      this.div = null
      this.visible = true
      this.map_ = null
    }

    onAdd() {
      this.div = document.createElement('div')
      this.div.className = 'devices-monitor'
      this.div.style.position = 'absolute'
      this.div.style.pointerEvents = 'none'
      this.div.style.display = this.visible ? '' : 'none'

      const dot = document.createElement('div')
      dot.className = 'radar-md-red'
      this.div.appendChild(dot)

      this.getPanes().overlayLayer.appendChild(this.div)
    }

    draw() {
      if (!this.div) return
      const point = this.getProjection().fromLatLngToDivPixel(this.position)
      if (!point) return
      this.div.style.left = `${point.x - 6}px`
      this.div.style.top = `${point.y - 6}px`
    }

    onRemove() {
      if (this.div && this.div.parentNode) {
        this.div.parentNode.removeChild(this.div)
      }
      this.div = null
    }

    getPosition() {
      return this.position
    }

    getDraggable() {
      return false
    }

    getVisible() {
      return this.visible
    }

    setVisible(visible) {
      this.visible = visible
      if (this.div) this.div.style.display = visible ? '' : 'none'
    }

    getMap() {
      return this.map_
    }

    // MarkerClustererPlus calls setMap(null) both to "hide" a marker that got
    // grouped into a cluster, and later when it's actually removed. We only want
    // the former to keep the div (and its pulse animation) alive, so treat every
    // setMap(null) as a visual toggle and reserve destroyOverlay() for real teardown.
    setMap(map) {
      this.map_ = map
      if (map) {
        if (this.div) {
          this.div.classList.remove('is-clustered')
        } else {
          super.setMap(map)
        }
      } else if (this.div) {
        this.div.classList.add('is-clustered')
      }
    }

    destroyOverlay() {
      super.setMap(null)
    }
  }

  return PulseMarkerOverlay
}
